import {Service} from "angular-ecmascript/module-helpers";

export var Name = 'bookingProcessorSelectionModal';

export default class BookingProcessorSelectionModal extends Service {
    static $name = Name;
    static $inject = ['$q', '$rootScope', '$ionicPopup', '$translate'];

    show(options) {
        var popup = null;
        var defer = this.$q.defer();

        var scope = this.$rootScope.$new(true);
        scope.$selectedProcessor = options.selectedProcessor;
        scope.$selectProcessor = (processor)=> {
            defer.resolve(processor);
            popup.close();
        };

        this.$translate([
            'BOOKING_PROCESSOR',
            'CANCEL',
            'WITHOUT',

        ]).then((translations) => {
            popup = this.$ionicPopup.show({
                template: '<booking-processor-selection selected-processor="$selectedProcessor" on-processor-selected="$selectProcessor(processor)"></booking-processor-selection>',
                title: translations.BOOKING_PROCESSOR,
                scope: scope,
                cssClass: 'booking-state-selection',
                buttons: [{
                    text: translations.CANCEL,
                    type: 'button-stable button-clear'
                }, {
                    text: translations.WITHOUT,
                    type: 'button-stable button-clear',
                    onTap: () => {
                        scope.$selectProcessor(null);
                    }
                }]
            });
        });

        return defer.promise;
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/components/booking-processor-selection/booking-processor-selection.modal.js